import React, { useEffect, useRef, useState } from 'react'
import '@/Account/ui/assets/login.css'
import i18n from '@/i18n'
import { OreButton, OreText } from '@edenredespana/oreneta'
import { LangOptions } from "@/Account/domain/navbarModel";
import { availableLangs } from '@/Account/domain/langOptions'

export const LangSelector: React.FC = () => {
  const isInitialized = useRef(false)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [langLabel, setLangLabel] = useState<string>('ES')

  const dropdownRef = useRef<HTMLDivElement>(null)

  const langs: LangOptions[] = availableLangs.map((lang) => ({
    label: lang.label,
    value: lang.value ?? 'es',
  }))

  useEffect(() => {
    if (!isInitialized.current) {
      isInitialized.current = true
      handleSelect(localStorage.getItem('i18nextLng') ?? 'ES')
    }
  }, [])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (value: string) => {
    i18n.changeLanguage(value)
    localStorage.setItem('i18nextLng', value);
    const langCode = value.split('-')[0].toUpperCase()
    setLangLabel(langCode)
    setIsOpen(false)
  }
  
  return (
    <>
      <OreButton onClick={handleToggle} category="tertiary">
        <OreText>{langLabel}</OreText>
      </OreButton>
      {isOpen && (
        <div ref={dropdownRef} className="dropdown-list">
          {langs.map((lang, index) => (
            <div
              key={index}
              className="list-item"
              onClick={() => handleSelect(lang.value)}>
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </>
  )
}